import { render } from "./EventDetail.vue?vue&type=template&id=b864189c&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"

import "./EventDetail.vue?vue&type=style&index=0&id=b864189c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b864189c"]])

export default __exports__